module.exports = __webpack_public_path__ + "img/img36.6279fa5f.svg";